import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BookOpen, Landmark } from "lucide-react";

// Public (no-login) counts, always fetched dynamically from the DB.
export const PublicStats = () => {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/public/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);
  if (!stats) return null;
  const fmt = (n) => Number(n || 0).toLocaleString("pt-BR");
  const publicTotal = stats.total;
  const publicByBanca = stats.by_banca || [];
  const slug = (s) => (s || "").toLowerCase().replace(/\s+/g, "-");

  return (
    <div className="mt-6 space-y-3">
      <div data-testid="public-questions-total" className="rounded-2xl border border-slate-800 bg-slate-900 p-5 text-center">
        <div className="flex items-center justify-center gap-2 text-emerald-400">
          <BookOpen className="h-5 w-5" />
          <span className="text-xs font-bold uppercase tracking-wide">Banco de Questões</span>
        </div>
        <p data-testid="public-questions-total-value" className="mt-1 font-mono-stats text-3xl font-extrabold text-white">
          +{fmt(publicTotal)}
        </p>
        <p className="text-xs text-slate-400">questões disponíveis</p>
      </div>

      {publicByBanca.length > 0 && (
        <div className="rounded-2xl border border-slate-800 bg-slate-900 p-5">
          <div className="mb-3 flex items-center gap-2 text-slate-300">
            <Landmark className="h-4 w-4 text-amber-400" />
            <span className="text-xs font-bold uppercase tracking-wide">Questões por banca</span>
          </div>
          <div className="flex flex-wrap gap-2">
            {publicByBanca.map((b) => (
              <span key={b.banca} data-testid={`public-banca-${slug(b.banca)}`}
                className="flex items-center gap-1.5 rounded-full border border-slate-700 bg-slate-800 px-3 py-1.5 text-xs font-semibold text-slate-200">
                {b.banca}
                <span className="font-mono-stats text-emerald-400">{fmt(b.count)}</span>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
